import { useState } from "react";
import FancyBookModal from "./FancyBookModal";
import { useGetFancyBookQuery } from "../services/sports/sportsApi";

const FancyTable = ({ oddsData, eventSummary, beventId, eventBets, fanciesWithBets }) => {
  const [selectedFancy, setSelectedFancy] = useState(null);

  const sections = (oddsData?.fancy || []).flatMap(market => market.section || []);
  const teamsExposure = eventSummary?.teams || [];

  // Green row = jis fancy pe bet lagi hai. Page load pe hi /api/fancies/with-bets se (Bets tab kholne ki zaroorat nahi);
  // Bets tab khula ho to uski list bhi jod lo.
  const fancyIdsWithBets = [...new Set([
    ...(fanciesWithBets?.data || []).map(f => f.fancyId),
    ...(eventBets?.data?.fancy || []).map(b => b.fancyId),
  ].filter(Boolean).map(String))];


  const getOddsByName = (section, oddName) => section.odds?.find(o => o.oname === oddName)?.odds || 0;
  const getExposureBySid = (sid) => teamsExposure.find(t => t.sid === sid)?.exposure || 0;

  const handleBookClick = (section) => {
    setSelectedFancy({ fancyId: section.fancyId, beventId, nation: section.nat });
    if (refetchBook) setTimeout(() => refetchBook(), 100);
  };

  const handleCloseModal = () => setSelectedFancy(null);

  const { data: bookData, isLoading: isBookLoading, isFetching: isBookFetching, refetch: refetchBook } = useGetFancyBookQuery(
    { fancyId: selectedFancy?.fancyId, beventId: selectedFancy?.beventId },
    { skip: !selectedFancy }
  );

  return (
    <div className="betting-table bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden mt-4">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0c1524] to-[#162032] px-4 py-2.5 flex items-center gap-2.5">
        <div className="w-1 h-5 bg-amber-400 rounded-full" />
        <span className="text-white font-semibold text-sm tracking-wide">Fancy</span>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr>
              <th className="p-2 border border-slate-200 text-left text-xs font-bold text-slate-500 bg-slate-50" style={{ width: '48%' }}>Market</th>
              <th className="p-2 border border-slate-200 text-center text-xs font-bold text-slate-500 bg-slate-50" style={{ width: '10%' }}>Book</th>
              <th className="p-2 border border-slate-200 text-center text-xs font-bold text-white bg-[#f994ba]" style={{ width: '21%' }}>No</th>
              <th className="p-2 border border-slate-200 text-center text-xs font-bold text-white bg-[#72bbef]" style={{ width: '21%' }}>Yes</th>
            </tr>
          </thead>
          <tbody>
            {sections.length === 0 ? (
              <tr>
                <td colSpan="4" className="py-8 text-center text-slate-400 text-xs">No fancy data</td>
              </tr>
            ) : (
              sections.map((section) => {
                const backOdds = getOddsByName(section, "back1");
                const layOdds  = getOddsByName(section, "lay1");
                const hasBets  = fancyIdsWithBets.includes(String(section.fancyId));
                const exposure = getExposureBySid(section.sid);
                const isSuspended =
                  section.gstatus === 'SUSPENDED' ||
                  section.gstatus === 'Ball Running' ||
                  (backOdds === 0 && layOdds === 0);

                return (
                  <tr key={section.sid} className={hasBets ? 'has-bets' : ''}>
                    <td className="border border-slate-200 p-2">
                      <div className="font-semibold text-slate-800 text-xs">{section.nat}</div>
                      {exposure !== 0 && (
                        <div className={`text-xs mt-0.5 ${exposure >= 0 ? 'text-emerald-600' : 'text-red-500'}`}>
                          {exposure.toFixed(2)}
                        </div>
                      )}
                    </td>
                    <td className="border border-slate-200 text-center p-2">
                      <button
                        onClick={() => handleBookClick(section)}
                        className="bg-[#0c1524] hover:bg-[#162032] text-white px-2.5 py-1 rounded-md text-[11px] font-semibold transition-colors"
                      >
                        Book
                      </button>
                    </td>
                    {isSuspended ? (
                      <td colSpan={2} className="odd-susp border border-slate-200 text-center p-2">
                        <span className="font-bold text-red-400 text-sm tracking-widest">{section.gstatus || 'SUSPENDED'}</span>
                      </td>
                    ) : (
                      <>
                        <td className="odd-lay border border-slate-200 text-center p-2">
                          <span className="font-bold text-slate-800 text-sm">{layOdds || '-'}</span>
                        </td>
                        <td className="odd-back border border-slate-200 text-center p-2">
                          <span className="font-bold text-slate-800 text-sm">{backOdds || '-'}</span>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <FancyBookModal
        isOpen={!!selectedFancy}
        onClose={handleCloseModal}
        fancyId={selectedFancy?.fancyId}
        beventId={selectedFancy?.beventId}
        nation={selectedFancy?.nation}
        bookData={isBookLoading || isBookFetching ? null : bookData}
        isLoading={isBookLoading || isBookFetching}
      />
    </div>
  );
};

export default FancyTable;
